import React, { useContext } from 'react'
import styled from 'styled-components'
import { Box, Divider, Image } from 'pcln-design-system'
import getCobrandContent from './constants'
import BootstrapDataContext from '../../context/BootstrapDataContext'

const StyledImage = styled(Image)`
  margin: auto;
  padding-bottom: 8px;
  padding-top: 8px;
`

// Displays when users are navigated to Priceline through referral partners

export default function Cobrand() {
  const { referral: { id = '', sourceId = '' } = {} } = useContext(
    BootstrapDataContext
  )
  const refid = sourceId + id
  const promo = getCobrandContent(refid)

  return promo ? (
    <Box color="background.lightest" width={1}>
      <Divider borderColor="border.base" my={0} />
      <StyledImage alt={promo.alt} src={promo.src} />
    </Box>
  ) : null
}
